import type { ReactiveController, ReactiveControllerHost } from "lit";

/** Keeps only the newest request alive, so a slow earlier response can never overwrite a newer one. */
export class LatestRequest implements ReactiveController {
    private _controller?: AbortController;

    constructor(host: ReactiveControllerHost) {
        host.addController(this);
    }

    start(): AbortSignal {
        this.abort();
        this._controller = new AbortController();
        return this._controller.signal;
    }

    abort() {
        this._controller?.abort();
        this._controller = undefined;
    }

    hostDisconnected() {
        this.abort();
    }
}
